import { api } from '@/lib/api';
import type {
  AppNotification,
  NotificationCount,
  PaginatedNotifications,
} from '@/types/notification.types';

const BASE = '/core/notifications';

export const notificationService = {
  async list(page = 1, pageSize = 20): Promise<PaginatedNotifications> {
    const { data } = await api.get<PaginatedNotifications>(BASE, {
      params: { page, pageSize },
    });
    return data;
  },

  async listUnread(): Promise<AppNotification[]> {
    const { data } = await api.get<AppNotification[]>(`${BASE}/unread`);
    return data;
  },

  async getCount(): Promise<NotificationCount> {
    const { data } = await api.get<NotificationCount>(`${BASE}/count`);
    return data;
  },

  async markAsRead(id: number): Promise<AppNotification> {
    const { data } = await api.patch<AppNotification>(`${BASE}/${id}/read`);
    return data;
  },

  async markAllAsRead(): Promise<{ count: number }> {
    const { data } = await api.patch<{ count: number }>(`${BASE}/read-all`);
    return data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};
